module.exports = __webpack_public_path__ + "img/plusSign_b.af133ce0.svg";